module.exports = __webpack_public_path__ + "img/5.2-安全管理与应急响应不足.2b46da7a.png";